module.exports = "<button type=\"button\" class=\"close closeModal\" data-dismiss=\"modal\" ng-click=\"$ctrl.dismiss({$value: {close: true}})\">\n    <span aria-hidden=\"true\">&times;</span>\n</button>\n<div>\n    <div class=\"modal-header\">\n        <span class=\"modal-title\" id=\"modal-title\">Provide credit or debit card details</span>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n        <as-loading-icon show=\"$ctrl.isRendering\"></as-loading-icon>\n        <div id=\"zuora_payment\"></div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/billing/components/billing-modal-payment-form/billingModalPaymentForm.component.html
// module id = 491
// module chunks = 0